import { renderEmail } from '../email-composer/email/render'
import { sectionDefaults } from '../email-composer/email/sections'
import { resolveTheme, FONTS } from '../email-composer/email/theme'

// A plain picture in the brand colour, standing in for a photo
const swatch = (hex, opacity) => `data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="300" height="200"><rect width="300" height="200" fill="${hex}" fill-opacity="${opacity}"/></svg>`)}`

// How every email opens, in the salon's brand: the header with the logo, a
// line of copy and a button. Shared by Config's summary and Your brand.
export const previewHtml = (spec) => {
  const theme = resolveTheme(spec)
  const blocks = [
    { id: 'h', type: 's-header', content: { ...sectionDefaults('s-header'), layout: 'center', showLogo: true, divider: false, tone: 'paper' } },
    { id: 't', type: 's-text', content: { ...sectionDefaults('s-text'), eyebrow: 'A little note', heading: 'Hello *{{FirstName}}*', body: 'Every email you send opens like this, with your logo, colour and type.', align: 'center', size: 's', tone: 'paper', py: 's' } },
    { id: 'b', type: 's-button', content: { ...sectionDefaults('s-button'), text: 'Book now', url: '#', align: 'center', note: '', tone: 'paper' } },
    // Two cards with pictures, so the Corners control has something to round
    { id: 'c', type: 's-cards', content: { ...sectionDefaults('s-cards'), eyebrow: '', heading: 'Worth a look', style: 'card', imageShape: 'landscape', tone: 'paper',
      items: [
        { image: swatch(theme.palette.accent, 0.9), title: 'Cut and colour', text: 'A fresh look for autumn.', link: '', url: '#' },
        { image: swatch(theme.palette.accent, 0.45), title: 'Gloss treatment', text: 'Shine that lasts.', link: '', url: '#' },
      ] } },
  ]
  try {
    return renderEmail(blocks, { theme, sample: { FirstName: 'Sophie', SalonName: spec.name || 'Your salon' } })
  } catch (e) {
    return ''
  }
}

export const fontName = (key) => (FONTS[key] ? FONTS[key].label : 'System')

// Where Your brand is edited, under Marketing › Config
export const BRAND_PAGE = '/marketing-brand'
export const CONFIG_PAGE = '/marketing-setting'
